import PropTypes from 'prop-types';
import { NavLink  } from 'react-router-dom';

const SeccionPageHeader = ({ title, idCabezaFamilia, url, nombreurl, nombreform }) => {
  return (
    <section className="content-header">
        <div className="container-fluid">
            <div className="row mb-2">
            <div className="col-sm-6">
                <h1 className="m-0">{title}</h1>
            </div>
            <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={url} >{nombreurl}</NavLink></li>}
                <li className="breadcrumb-item active"> {nombreform}</li>
                </ol>
            </div>
            </div>
        </div>
    </section>
  );
};

SeccionPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  idCabezaFamilia: PropTypes.string,
  url: PropTypes.string,
  nombreurl: PropTypes.string,
  nombreform: PropTypes.string
};

export default SeccionPageHeader
